import React from 'react';

const Input = ({ label, error, icon: Icon, className = '', ...props }) => (
  <div className={className}>
    {label && <label className="block text-sm font-medium text-slate-300 mb-2">{label}</label>}
    <div className="relative">
      {Icon && (
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500">
          <Icon size={18} />
        </div>
      )}
      <input
        className={`
          w-full bg-slate-700/50 border rounded-xl py-2.5 px-4 text-white 
          placeholder-slate-500 focus:outline-none focus:border-emerald-500 transition-colors
          ${Icon ? 'pl-10' : ''} 
          ${error ? 'border-rose-500' : 'border-slate-600'}
        `}
        {...props}
      />
    </div>
    {error && <p className="mt-1 text-sm text-rose-400">{error}</p>}
  </div>
);

export default Input;
